// Alternative Arabic text constants using different encoding methods
export const ARABIC_TEXTS = {
  DASHBOARD: 'Dashboard', // لوحة التحكم
  USER_MANAGEMENT: 'User Management', // إدارة المستخدمين
  ADMIN_MANAGEMENT: 'Admin Management', // إدارة المشرفين
  FORM_MANAGEMENT: 'Form Management', // استمارات الفحص
  SETTINGS: 'Settings', // الإعدادات
  ADMIN: 'Admin', // مشرف
  EDITOR: 'Editor', // محرر
  SYSTEM_ADMIN: 'System Admin', // مشرف النظام
  LOGOUT: 'Logout' // تسجيل الخروج
};

// Alternative approach using hex encoding for Arabic text
export const ARABIC_TEXTS_HEX = {
  DASHBOARD: '\u0644\u0648\u062d\u0629\u0020\u0627\u0644\u062a\u062d\u0643\u0645',
  USER_MANAGEMENT: '\u0625\u062f\u0627\u0631\u0629\u0020\u0627\u0644\u0645\u0633\u062a\u062e\u062f\u0645\u064a\u0646',
  ADMIN_MANAGEMENT: '\u0625\u062f\u0627\u0631\u0629\u0020\u0627\u0644\u0645\u0634\u0631\u0641\u064a\u0646',
  FORM_MANAGEMENT: '\u0627\u0633\u062a\u0645\u0627\u0631\u0627\u062a\u0020\u0627\u0644\u0641\u062d\u0635',
  PRODUCT_MANAGEMENT: '\u0625\u062f\u0627\u0631\u0629\u0020\u0627\u0644\u0645\u0646\u062a\u062c\u0627\u062a',
  PRICING_MANAGEMENT: '\u0625\u062f\u0627\u0631\u0629\u0020\u0627\u0644\u062a\u0633\u0639\u064a\u0631',
  SETTINGS: '\u0627\u0644\u0625\u0639\u062f\u0627\u062f\u0627\u062a',
  ADMIN: '\u0645\u0634\u0631\u0641',
  EDITOR: '\u0645\u062d\u0631\u0631',
  SYSTEM_ADMIN: '\u0645\u0634\u0631\u0641\u0020\u0627\u0644\u0646\u0638\u0627\u0645',
  LOGOUT: '\u062a\u0633\u062c\u064a\u0644\u0020\u0627\u0644\u062e\u0631\u0648\u062c'
};
